import '../Authenticate.css';
import { Link } from 'react-router-dom';
import { useRef, useState } from 'react';
import { AuthService } from '../../../../services/AuthService';
import Turnstile from '../../../../common/turnstile/Turnstile';

// Asking for a password-reset link. The API deliberately answers the same whether or not the address
// has an account, so this page shows the same message either way — telling the visitor "no account
// uses that address" would let anyone check who is registered.

const SENT_MESSAGE = 'You will receive a link to reset your password if an account with that email address exists.';

export default function ForgotPassword() {

    const [email, setEmail] = useState('');
    const [sent, setSent] = useState(false);
    const [error, setError] = useState('');
    const [sending, setSending] = useState(false);
    const turnstileRef = useRef(null);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setSending(true);

        let captchaToken;
        try {
            captchaToken = await turnstileRef.current?.getFreshToken();
        } catch {
            setError('Please complete the check that shows you are human, then try again.');
            setSending(false);
            return;
        }

        const body = captchaToken ? { email, turnstile_token: captchaToken } : { email };
        const result = await AuthService.makeRequest({
            urlExtension: 'user/password-reset/',
            method: 'POST',
            body,
        });
        setSending(false);

        if (result.error) {
            setError(result.data?.detail || result.data?.email?.[0]
                || 'That did not work. Please check the address and try again.');
            return;
        }
        setSent(true);
    };

    if (sent) {
        return (
            <main className='authenticate-main'>
                <h2>Check your email</h2>
                <p className='authenticate-intro'>{SENT_MESSAGE}</p>
                <p className='authenticate-toggle-format'>
                    <Link className='underline' to={'/user/login'}>Back to log in</Link>
                </p>
            </main>
        );
    }

    return (
        <main className='authenticate-main'>
            <h2>Forgot your password?</h2>
            <p className='authenticate-intro'>Enter the email address for your account and we will send you a link to set a new password.</p>
            <form onSubmit={handleSubmit} className='authenticate-form'>
                <label className='authenticate-form-field'>
                    <span>Email</span>
                    <br></br>
                    <input className='authenticate-form-input' type='text' value={email}
                           onChange={(e) => setEmail(e.target.value)} required />
                    {error ? <p><i className="fa-solid fa-circle-info"></i> {error}</p> : ''}
                </label>
                <div className='authenticate-form-field'>
                    <Turnstile ref={turnstileRef} action='password-reset' />
                </div>
                <button className="btn-login" type='submit' disabled={sending}>
                    {sending ? 'Sending…' : 'Send the link'}
                </button>
            </form>
            <p className='authenticate-toggle-format'>
                <span>Remembered it? </span>
                <Link className='underline' to={'/user/login'}>Log in</Link>
            </p>
        </main>
    );
}
